import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS_API } from 'src/app/constant/config';
import axios from '../app/axiosInterceptor';
import instance from 'src/app/axiosInterceptor';
import Cookie from 'js-cookie';
import { roles } from 'src/app/constant/roles';
import { getAgencyConfig } from './agencySlice';
export const Login = createAsyncThunk(
  'AuthSlice/login',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: payload
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const GetAgencyWallet = createAsyncThunk(
  'AuthSlice/GetAgencyWallet',
  async (agencyId, { rejectWithValue }) => {
    try {
      const res = await instance.get(`/agencies/${agencyId}`);
      return res.data;
    } catch (err) {
      // axiosInterceptor rejects with the raw response object (or a message
      // string for network errors), so read status/data off `err` directly.
      if (typeof err === 'string') {
        return rejectWithValue({ message: err });
      }
      return rejectWithValue({
        status: err?.status,
        message: err?.data?.message || 'Unknown error'
      });
    }
  }
);

export const GetUserInfo = createAsyncThunk(
  'User/GetInfo',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await instance.get('/users/information');
      const user = res.data?.payload?.user;
      if (user?.role?.title === roles.AGENCY && user?.agency?.id) {
        dispatch(GetAgencyWallet(user.agency.id));
      }

      return res.data;
    } catch (err) {
      if (!err.response) {
        return rejectWithValue(err.message || 'Network Error');
      }
      return rejectWithValue(err.response.data || 'Unknown error');
    }
  }
);


const ADMIN_SCOPE_ROLES = [roles.ADMIN, roles.CUSTOMER_CARE, roles.SALE];

function applyUserToState(state, user) {
  state.isAdmin = user?.role?.title === roles.ADMIN;
  state.isAgency = user?.role?.title === roles.AGENCY;
  state.isStaff = user?.role?.title === roles.STAFF;
  state.isUser = user?.role?.title === roles.ENDUSER;
  state.isAccountant = user?.role?.title === roles.ACCOUNTANT;
  state.isSale = user?.role?.title === roles.SALE;
  state.isCustomerCare = user?.role?.title === roles.CUSTOMER_CARE;
  state.isLeadMarketing =
    Boolean(user) &&
    (user.role?.title === roles.LEAD_MARKETING || user.role_id === 11);
  state.isTechnician = user?.role_id === 8;
  state.isDriver = user?.role_id === 10;

  state.agencyId = user?.role?.title === roles.AGENCY ? user.agency.id : undefined;
  state.agencyLevel =
    user?.role?.title === roles.AGENCY ? Number(user.agency.level) || null : null;
  if (user?.role?.title !== roles.AGENCY) {
    state.allowEditCustomer = false;
    state.allowSwap = false;
    state.allowSwapSubAgency = false;
  } else {
    if (user.agency?.allow_edit_customer !== undefined) {
      state.allowEditCustomer = user.agency.allow_edit_customer === true;
    }
    if (user.agency?.is_allow_swap !== undefined) {
      state.allowSwap = user.agency.is_allow_swap === true;
    }
    if (user.agency?.is_allow_swap_sub_agency !== undefined) {
      state.allowSwapSubAgency = user.agency.is_allow_swap_sub_agency === true;
    }
  }
  state.userId = user?.role?.title === roles.ENDUSER ? user.endUser.id : undefined;
  state.adminId = ADMIN_SCOPE_ROLES.includes(user?.role?.title) ? user.id : undefined;
  state.driverId = user?.role_id === 10 ? user.id : undefined;

  const rawAgencyId = user?.agency_id || user?.agency?.id;
  const isSaleScope = state.isSale || state.isLeadMarketing;
  // Nhánh Sale Admin: không gắn agency_id (agency_id null hoặc undefined)
  state.isAdminSale = isSaleScope && !rawAgencyId;
  // Nhánh Sale Vmake / Đại lý: có gắn agency_id (> 0)
  state.isAgencySale = isSaleScope && Boolean(rawAgencyId);
  state.isVmakeSale = state.isAgencySale;

  state.isLogin = true;
}

export const UpdateInfoBySelf = createAsyncThunk(
  'User/UpdateInfoBySelf',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/update/self`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        data: payload
      })
        .then(res => resolve(payload))
        .catch(err => {
          if (!err.response) reject(err?.message);
          reject(rejectWithValue(err.response?.data || null));
        });
    });
  }
);
export const Register = createAsyncThunk(
  'AuthSlice/register',
  (payload, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/register`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: payload
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const ChangePassword = createAsyncThunk(
  'AuthSlice/ChangePassword',
  ({ new_password, id }, { rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/auth/password/${id}`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access-token')
        },
        data: { new_password: new_password }
      })
        .then(res => resolve(res.data))
        .catch(err => {
          if (!err.response) reject(err.message);
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);


export const authSlice = createSlice({
  name: 'authSlice',
  initialState: {
    isLoadingLogin: false,
    failStatus: null,
    dataLogin: null,
    isLogin: false,
    //  state for register
    isLoadingRegister: false,
    failRegisterStatus: null,
    dataRegister: null,
    isRegisterSuccess: false,
    // state for case reload
    isGettingInfo: false,
    errGetting: null,
    // update user by self
    isUpdatingInfoBySelf: false,
    isUpdateBySelfSuccess: false,
    errUpdateBySelf: null,
    isChangePassword: STATUS_API.PENDING,
    errorChangePassword: null,
    isLoadingChangePassword: false,

    isAdmin: false,
    isAgency: false,
    isStaff: false,
    isUser: false,
    isAccountant: false,
    isSale: false,
    isCustomerCare: false,
    isLeadMarketing: false,
    isAdminSale: false,
    isAgencySale: false,
    isVmakeSale: false,
    isTechnician: false,
    isDriver: false,
    agencyId: null,
    agencyLevel: null,
    allowEditCustomer: false,
    allowSwap: false,
    allowSwapSubAgency: false,
    walletBalance: null,
    userId: null,
    adminId: null,
    driverId: null,
    idSocket: null,
  },
  reducers: {
    logOutAction: state => {
      state.isLogin = false;
      state.failStatus = null;
      Cookie.remove('access-token');
      localStorage.removeItem('access-token');
      localStorage.removeItem('agency-id');
      localStorage.removeItem('refresh-token');
    },
    loginSuccessAction: state => {
      state.isLogin = true;
    },
    finishRegisterAction: state => {
      state.isRegisterSuccess = false;
    },
    clearMassageErrorAction: state => {
      state.failStatus = null;
      state.failRegisterStatus = null;
    },
    clearMsgUpdate: state => {
      state.errUpdateBySelf = null;
      state.isUpdateBySelfSuccess = false;
    },
    resetChangePassword: state => {
      state.isChangePassword = STATUS_API.PENDING;
      state.isLoadingChangePassword = false;
    },
    updateWalletBalance: (state, action) => {
      state.walletBalance = action.payload;
    }
  },
  extraReducers: {
    [Login.pending]: state => {
      state.isLoadingLogin = true;
      state.errGetting = null;
      state.failStatus = null;
    },
    [Login.fulfilled]: (state, action) => {
      state.isLoadingLogin = false;
      state.dataLogin = action.payload.payload.user;
      state.failStatus = null;

      const user = action.payload.payload.user;
      applyUserToState(state, user);
      state.idSocket = user.id || undefined;

      Cookie.set('access-token', action.payload.payload['token']);
      localStorage.setItem('access-token', action.payload.payload['token']);
      localStorage.setItem(
        'refresh-token',
        action.payload.payload['refresh_token']
      );
      // Wake up the token watcher / WS hooks listening for token changes.
      window.dispatchEvent(new Event('access-token-updated'));

      if (action.payload.payload.user.agency != null)
        localStorage.setItem(
          'agency-id',
          action.payload.payload.user.agency.id
        );
    },
    [Login.rejected]: (state, action) => {
      state.isLoadingLogin = false;
      state.failStatus = {
        message: 'Đăng nhập thất bại vui lòng kiểm tra lại thông tin',
      };
    },
    // register call api
    [Register.pending]: state => {
      state.isLoadingRegister = true;
      state.errGetting = null;
    },
    [Register.fulfilled]: (state, action) => {
      state.isLoadingRegister = false;
      state.dataRegister = action.payload.payload;
      state.isRegisterSuccess = true;
      Cookie.set('access-token', action.payload.payload['access-token']);
    },
    [Register.rejected]: (state, action) => {
      state.isLoadingRegister = false;
      state.failRegisterStatus = action.payload || action.error;
    },
    // get user info api
    [GetUserInfo.pending]: state => {
      state.isGettingInfo = true;
      state.errGetting = null;
    },
    [GetUserInfo.fulfilled]: (state, action) => {
      state.isGettingInfo = false;
      state.dataLogin = action.payload.payload.user;
      const user = action.payload.payload.user;
      applyUserToState(state, user);
      state.idSocket = user.id || undefined;
    },
    [GetUserInfo.rejected]: (state, action) => {
      state.isGettingInfo = false;
      state.errGetting = action.payload || action.error;
      // Session is dead (refresh already failed inside the interceptor) —
      // clear the stale logged-in state instead of keeping it around.
      if (action.payload?.status === 401) {
        state.isLogin = false;
        state.dataLogin = null;
      }
    },
    //   update user by self
    [UpdateInfoBySelf.pending]: state => {
      state.isUpdatingInfoBySelf = true;
      state.errUpdateBySelf = null;
      state.isUpdateBySelfSuccess = false;
      state.errGetting = null;
    },
    [UpdateInfoBySelf.fulfilled]: (state, action) => {
      state.isUpdatingInfoBySelf = false;
      state.isUpdateBySelfSuccess = true;
      state.dataLogin = action.payload;
    },
    [UpdateInfoBySelf.rejected]: (state, action) => {
      state.isUpdatingInfoBySelf = false;
      state.errUpdateBySelf = action.payload?.message || action.error;
    },
    //   Change password
    [ChangePassword.pending]: state => {
      state.isLoadingChangePassword = true;
      state.errorChangePassword = null;
      state.isChangePassword = STATUS_API.PENDING;
    },
    [ChangePassword.fulfilled]: (state, action) => {
      state.isLoadingChangePassword = false;
      state.errorChangePassword = null;
      state.isChangePassword = STATUS_API.SUCCESS;
    },
    [ChangePassword.rejected]: (state, action) => {
      state.isLoadingChangePassword = false;
      state.isChangePassword = STATUS_API.ERROR;
      state.errorChangePassword = action.payload?.message || action.error;
    },
    // Đồng bộ cờ cấu hình của chính đại lý đang đăng nhập
    [getAgencyConfig.fulfilled]: (state, action) => {
      const { agencyId, is_allow_swap, is_allow_swap_sub_agency } = action.payload || {};
      if (state.isAgency && agencyId === state.agencyId) {
        state.allowSwap = is_allow_swap === true;
        state.allowSwapSubAgency = is_allow_swap_sub_agency === true;
      }
    },
    [GetAgencyWallet.fulfilled]: (state, action) => {
      const agency = action.payload?.payload?.agency;
      if (agency) {
        if (agency.wallet) {
          state.walletBalance = agency.wallet.balance ?? null;
        }
        if (agency.level !== undefined && agency.level !== null) {
          state.agencyLevel = Number(agency.level);
        }
        state.allowEditCustomer = agency.allow_edit_customer === true;
        if (agency.is_allow_swap !== undefined) {
          state.allowSwap = agency.is_allow_swap === true;
        }
        if (agency.is_allow_swap_sub_agency !== undefined) {
          state.allowSwapSubAgency = agency.is_allow_swap_sub_agency === true;
        }
      }
    }
  }
});
export const {
  logOutAction,
  loginSuccessAction,
  finishRegisterAction,
  clearMassageErrorAction,
  clearMsgUpdate,
  resetChangePassword,
  updateWalletBalance
} = authSlice.actions;

export default authSlice.reducer;
